import script from "./document-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./document-modal.vue?vue&type=script&setup=true&lang=js"

import "./document-modal.vue?vue&type=style&index=0&id=9cc3fa32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cc3fa32"]])

export default __exports__